import React, { memo, useCallback, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { IconVolume, IconVolumeOff } from "@tabler/icons-react";
import { parseCookies } from "nookies";
import jwt_decode from "jwt-decode";
import {
  GetOne as GetUserOne,
  UpdateSoundAlertsPreference,
} from "../../../services/UsersServices";

const STORAGE_KEY = "serviceCenter.soundAlertsEnabled";

const readFromStorage = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === null) return true;
  return stored === "true";
};

const writeToStorage = (enabled) => {
  localStorage.setItem(STORAGE_KEY, enabled ? "true" : "false");
};

const getCurrentUserId = () => {
  const { token } = parseCookies();
  if (!token) return null;
  try {
    const decoded = jwt_decode(token);
    return decoded?.user_id || null;
  } catch (error) {
    return null;
  }
};

const SoundToggleButton = memo(() => {
  const [enabled, setEnabled] = useState(readFromStorage);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const userId = getCurrentUserId();
    if (!userId) return;

    let cancelled = false;
    GetUserOne(userId)
      .then((data) => {
        if (cancelled) return;
        const remote = data?.sound_alerts_enabled;
        if (typeof remote === "boolean") {
          setEnabled(remote);
          writeToStorage(remote);
        }
      })
      .catch(() => {
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const handleToggle = useCallback(async () => {
    const userId = getCurrentUserId();
    if (!userId || saving) return;

    const next = !enabled;
    setEnabled(next);
    writeToStorage(next);
    setSaving(true);

    try {
      await UpdateSoundAlertsPreference(userId, next);
    } catch (error) {
      setEnabled(!next);
      writeToStorage(!next);
    } finally {
      setSaving(false);
    }
  }, [enabled, saving]);

  return (
    <Button
      variant="outline-secondary"
      size="sm"
      onClick={handleToggle}
      disabled={saving}
      title={enabled ? "Desativar alerta sonoro" : "Ativar alerta sonoro"}
      aria-label={enabled ? "Desativar alerta sonoro" : "Ativar alerta sonoro"}
    >
      {enabled ? <IconVolume size={18} /> : <IconVolumeOff size={18} />}
    </Button>
  );
});

SoundToggleButton.displayName = "SoundToggleButton";

export default SoundToggleButton;
